module.exports = __webpack_public_path__ + "media/images/ui__infoOk--dark-f365ad1e0f732d641f59b0803eb920f4.png";